// Copyright (c) 2024 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap, tap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slices/additionalUi"
import { ACTION_PANE_NOTE_IS_HIDDEN } from "./index"

export type StorageWriter = (value: boolean) => void

export const persist: StorageWriter = (value) => {
  localStorage.setItem(ACTION_PANE_NOTE_IS_HIDDEN, value.toString())
}

export const persistActionPaneNoteIsHidden = (persist: StorageWriter) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Slice.setActionPaneNoteIsHidden.match),
      mergeMap(action => of(action.payload).pipe(
        tap(persist),
        map(_ => Actions.actionPaneNoteIsHiddenPersisted()),
        catchError(_ => of(Actions.actionPaneNoteIsHiddenPersistFailed())),
      )),
    )

export default persistActionPaneNoteIsHidden(persist)

